/*@flow*/
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { Link } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { BREAKPOINT_MD } from 'store/constants';

const Component = () => (
  <div
    css={css(
      'background: var(--brand-yellow);height: 1000px; padding-top: 10vh;'
    )}
  >
    <div className="container">
      <header css={css('width: 100%;')}>
        <div
          css={css(`width: 60%; text-align: right;

            @media (max-width: ${BREAKPOINT_MD.toString()}) {
              width: 100%;
              text-align: center;
            }
          `)}
        >
          <h1 css={css('font-weight: bold; margin-bottom: 4rem;')}>
            The Circular City
          </h1>
        </div>
      </header>
      <nav
        css={css(
          `
          width: 100%;
        `
        )}
      >
        <div
          css={css(`
          text-align: right;
          width: 60%;
          @media (max-width: ${BREAKPOINT_MD.toString()}) {
            width: 100%;
          }
          `)}
        >
          <Link
            to="/dashboard"
            css={css(`
            display: block;
            @media (max-width: ${BREAKPOINT_MD.toString()}) {
              text-align: center;
            }

            color: var(--brand-black);
            &:hover { color: black; }

            line-height: 1em;
            font-size: 2.4rem;
            margin-bottom: 3rem;

            text-decoration: underline !important;
          `)}
          >
            Downtown Brooklyn Dashboard
            <br />
            <b css={css('font-size: 1.4rem;')}>Demo</b>
          </Link>
          <p css={css('text-align: justify;')}>
            This demo brings together data from a variety of sources used to
            analyze Downtown Brooklyn. This dashboard was created to visualize
            the data generated and studied as part of The Circular City program.
            Use this dashboard to analyze and compare data about the
            neighborhood that can direct civic leaders, researchers, businesses,
            residents and other stakeholders to address challenges related to
            topics including mobility, economic development, sustainability and
            resilience.
          </p>
        </div>
      </nav>
      <footer
        css={css(
          `
        padding: 20px;
        display: grid;
        grid-template-rows: 1fr;
        & > div {
          width: 60%;
          @media (max-width: ${BREAKPOINT_MD.toString()}) {
            width: 100%;
          }
          text-align: justify;
        }
      `
        )}
      >
        <div>
          <p>
            <b>The Circular City</b> is a New Lab program launched in 2018 that
            brings together entrepreneurs, city leaders, corporate partners, and
            university innovators to tackle urban challenges. The program aims
            to accelerate the development, deployment and partnerships necessary
            to transform the way emerging technology positively impacts life in
            cities.
          </p>
          <p>
            <b>New Lab</b> is a platform for scaling frontier technologies. We
            champion the world’s most forward-thinking entrepreneurs and partner
            with corporate and city stakeholders to catalyze innovation.
          </p>
        </div>
      </footer>
    </div>
  </div>
);

export default hot(module)(Component);
